module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic-ext43.df55b7e.woff2";